import { initTranslation } from "../modules/i18n";
import initPage from "../modules/page";

async function initContactPage() {
  await initTranslation();
  initPage();
}

initContactPage();
